module.exports = __webpack_public_path__ + "img/fangan2.15978549.png";